import gql from 'graphql-tag'

export const RENEW_SERF_WITH_TOKEN = gql`
  mutation RenewSerfWithToken($hcp: SerfRenewHcpInput!, $serf: SerfCreationInput!, $token: String) {
    renewSerf(hcp: $hcp, serf: $serf, token: $token) {
      firstName
    }
  }
`
